export const getFormattedDate = () => {
  const currentDate = new Date();
  return `${currentDate.getDate().toString().padStart(2, "0")}/${(
    currentDate.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${currentDate.getFullYear()}`;
};

export const convertToNumberKWD = (value) => {
  if (typeof value === 'number') {
    return value; // Value is already a number, return it as is
  }
  if (typeof value === 'string') {
    // Remove "KWD" and trim any whitespace, then parse as a number
    const numericValue = parseFloat(value.replace("KWD", "").trim());
    return isNaN(numericValue) ? 0 : numericValue; // Return 0 if parsing results in NaN
  }
  return 0; // Return 0 for undefined, null, or other types
};

export const toNumber = (value) => (isNaN(value) ? 0 : parseFloat(value));

